import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, Star } from "lucide-react";
import { BUSINESS } from "../data/site";

export default function Footer() {
    return (
        <footer className="bg-slate-900 text-slate-300 mt-32">
            <div className="max-w-7xl mx-auto px-5 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
                <div className="md:col-span-2">
                    <div className="flex items-center gap-2.5">
                        <div className="h-10 w-10 rounded-xl bg-white text-slate-900 grid place-items-center font-display font-bold">EG</div>
                        <div>
                            <div className="font-display text-white text-lg font-bold">EG Wireless</div>
                            <div className="text-[10px] uppercase tracking-[0.2em] text-cyan-400">Glendale Wireless Experts</div>
                        </div>
                    </div>
                    <p className="mt-5 text-slate-400 max-w-md leading-relaxed">
                        Your trusted Glendale destination for smartphones, activations, accessories, wireless plans and expert technical support.
                    </p>
                    <div className="mt-5 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10">
                        <Star className="w-4 h-4 text-yellow-400 fill-yellow-400" />
                        <span className="text-sm text-white font-semibold">{BUSINESS.rating}</span>
                        <span className="text-xs text-slate-400">· {BUSINESS.reviewCount}+ Reviews</span>
                    </div>
                </div>

                <div>
                    <div className="text-white font-semibold mb-4">Explore</div>
                    <ul className="space-y-2 text-sm">
                        {[
                            ["/services", "Services"],
                            ["/products", "Products"],
                            ["/about", "About"],
                            ["/reviews", "Reviews"],
                            ["/faq", "FAQ"],
                            ["/location", "Location"],
                            ["/contact", "Contact"],
                        ].map(([to, label]) => (
                            <li key={to}>
                                <Link to={to} className="text-slate-400 hover:text-white transition">
                                    {label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <div className="text-white font-semibold mb-4">Visit us</div>
                    <ul className="space-y-3 text-sm">
                        <li className="flex items-start gap-2.5 text-slate-400">
                            <MapPin className="w-4 h-4 mt-0.5 text-cyan-400" />
                            <span>{BUSINESS.address}<br /><span className="text-slate-500 text-xs">Inside {BUSINESS.locatedInside}</span></span>
                        </li>
                        <li>
                            <a href={`tel:${BUSINESS.phoneRaw}`} className="flex items-center gap-2.5 text-slate-300 hover:text-white">
                                <Phone className="w-4 h-4 text-cyan-400" /> {BUSINESS.phone}
                            </a>
                        </li>
                        <li className="flex items-start gap-2.5 text-slate-400">
                            <Clock className="w-4 h-4 mt-0.5 text-cyan-400" />
                            <span>Mon–Fri 12–5 · Sat 12–4 · Sun 12–4</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/5">
                <div className="max-w-7xl mx-auto px-5 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500">
                    <div>© {new Date().getFullYear()} EG Wireless. All rights reserved.</div>
                    <Link to="/login" data-testid="footer-staff-login" className="hover:text-slate-300">Staff Login</Link>
                </div>
            </div>
        </footer>
    );
}
